import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { WoundOrderListTemplate } from "themes/application/wound-order/pages";
import { WoundOrderListViewStore } from "application/wound-order/stores";

@setCurrentView(rootStore => new WoundOrderListViewStore(rootStore), "woundOrderListViewStore")
@observer
class WoundOrderList extends React.Component {
    render() {
        return <WoundOrderListTemplate {...this.props} />;
    }
}

export default WoundOrderList;